// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dh-at-section {
  background: white;
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  border: 1px solid #f0f0f0;
  overflow: hidden;
}

.dh-at-academic-section {
  padding-bottom: 32px;
}

.dh-at-section-header {
  background: white;
  padding: 32px 0 0 40px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 10px;
}

.dh-at-section-title {
  color: #002FA7;
  font-size: 32px;
  font-weight: 700;
  margin: 0 0 24px 0;
}

.dh-at-section-subtitle {
  color: #64748b;
  font-size: 16px;
  margin: 0;
}

.dh-at-filters {
  display: flex;
  gap: 16px;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 14px;
  padding: 8px 32px 0 32px;
}

.dh-at-search-container {
  flex: 1 1;
  min-width: 250px;
}

.dh-at-search-input {
  width: 100%;
  padding: 10px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s ease;
}

.dh-at-search-input:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);
}

.dh-at-course-filter {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.dh-at-course-filter-btn {
  padding: 8px 16px;
  border: 1px solid #e2e8f0;
  background: white;
  color: #64748b;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.dh-at-course-filter-btn:hover {
  border-color: #002FA7;
  color: #002FA7;
}

.dh-at-course-filter-btn.active {
  background: #002FA7;
  color: white;
  border-color: #002FA7;
}

.dh-at-courses-container {
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-top: 24px;
}

.dh-at-course-section {
  width: 100%;
}

.dh-at-course-title {
  font-size: 20px;
  font-weight: 600;
  color: #002FA7;
  margin: 0 0 20px 0;
  padding-bottom: 12px;
  border-bottom: 2px dashed #e2e8f0;
  position: relative;
  padding: 0 32px 8px 32px;
}

.dh-at-groups-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 20px;
  padding: 0 32px 0 32px;
}

.dh-at-group-card {
  background: white;
  border-radius: 16px;
  padding: 20px;
  border: 1px solid #e2e8f0;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.dh-at-group-card:hover {
  border-color: #002FA7;
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(0, 47, 167, 0.12);
}

.dh-at-group-header {
  margin-bottom: 16px;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}

.dh-at-group-title {
  font-size: 20px;
  font-weight: 700;
  color: #002FA7;
  margin: 0;
}

.dh-at-group-badge {
  background: #002FA7;
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}

.dh-at-group-info {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 0;
}

.dh-at-group-specialty {
  font-size: 14px;
  color: #64748b;
  line-height: 1.4;
  padding-bottom: 8px;
  border-bottom: 1px dashed #e2e8f0;
}

.dh-at-group-details {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  font-size: 13px;
  color: #1f2937;
  margin: 0;
}

.dh-at-group-details span {
  background: #f8fafc;
  padding: 4px 12px;
  border-radius: 20px;
  color: #002FA7;
  font-weight: 500;
}

.dh-at-group-students {
  color: #002FA7;
  font-size: 14px;
  font-weight: 600;
  margin: 0;
}

.dh-at-group-footer {
  display: flex;
  justify-content: flex-end;
}

.dh-at-view-button {
  background: #002FA7;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.dh-at-view-button:hover {
  background: #1e40af;
  transform: translateX(4px);
}

.dh-at-no-groups {
  text-align: center;
  padding: 60px 24px;
  background: #f8fafc;
  border-radius: 16px;
  border: 2px dashed #e2e8f0;
  color: #64748b;
  font-size: 16px;
}

.dh-at-statement-wrapper {
  height: 100%;
  overflow: auto;
}

.dh-at-statement-header {
  background: #f8fafc;
  color: #002FA7;
  position: sticky;
  top: 0;
  z-index: 1;
  border-bottom: solid 1px #002fa7a3;
  padding: 16px 24px;
}

.dh-at-statement-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  width: 100%;
}

.dh-at-filters-left {
  display: flex;
  gap: 20px;
  align-items: center;
  flex-wrap: wrap;
  margin-right: auto;
}

.dh-at-filter-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.dh-at-filter-label {
  font-size: 14px;
  font-weight: 600;
  color: #002FA7;
  white-space: nowrap;
}

.dh-at-filter-select {
  padding: 8px 14px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 400;
  background: white;
  cursor: pointer;
  color: #1f2937;
  min-width: 100px;
  transition: all 0.2s ease;
}

.dh-at-filter-select:hover {
  border-color: #002FA7;
}

.dh-at-filter-select:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);
}

.dh-at-semester-buttons {
  display: flex;
  gap: 6px;
}

.dh-at-semester-btn {
  padding: 8px 18px;
  border: 1px solid #d1d5db;
  background: white;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 44px;
}

.dh-at-semester-btn:hover {
  border-color: #002FA7;
  color: #002FA7;
  background: #f0f7ff;
}

.dh-at-semester-btn.active {
  background: #002FA7;
  color: white;
  border-color: #002FA7;
  box-shadow: 0 2px 6px rgba(0, 47, 167, 0.3);
}

.dh-at-actions-right {
  display: flex;
  gap: 12px;
  align-items: center;
}

.dh-at-btn-primary,
.dh-at-btn-secondary,
.dh-at-btn-print {
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
  border: 1px solid #8aa3c4b8;
  background: white;
  color: #002FA7;
}

.dh-at-btn-primary:hover,
.dh-at-btn-secondary:hover,
.dh-at-btn-print:hover {
  transform: translateY(-1px);
}

.dh-at-main-content {
  display: flex;
  gap: 20px;
}

.dh-at-statement-body {
  flex: 1 1 auto;
  min-width: 0;
  padding: 0;
}

.dh-at-table-container {
  overflow-x: auto;
  padding: 0;
}

.dh-at-statement-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 11px;
  min-width: 2000px;
}

.dh-at-statement-table th,
.dh-at-statement-table td {
  border: 1px solid #9c9c9c81;
  padding: 6px 8px;
  text-align: center;
  vertical-align: middle;
}

.dh-at-statement-table th {
  background: #ffffff72;
  color: #012171;
  font-weight: 600;
  position: sticky;
  top: 0;
}

.dh-at-statement-table tr:nth-child(even) {
  background: #f8fafc;
}

.dh-at-statement-table tr:hover {
  background: #f0f7ff;
}

.dh-at-student-name {
  text-align: left !important;
  min-width: 180px;
  max-width: 180px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dh-at-average {
  font-weight: 600;
  color: #002FA7;
}

.dh-at-grade-select {
  width: 100%;
  padding: 4px;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  background: white;
  font-size: 11px;
  text-align: center;
}

.dh-at-na-button {
  background: #002FA7;
  color: white;
  border: none;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
}

.dh-at-na-button:hover {
  background: #b91c1c;
  transform: scale(1.05);
}

.dh-at-vertical-header {
  width: 70px;
  min-width: 70px;
  max-width: 70px;
  height: 250px;
  position: relative;
  vertical-align: bottom !important;
  padding: 0 !important;
  border-right: 1px solid rgba(255, 255, 255, 0.3);
}

.dh-at-vertical-text {
  transform: rotate(-90deg);
  transform-origin: center;
  position: absolute;
  top: 40%;
  left: -55px;
  width: 180px;
  height: 60px;
  font-size: 9px;
  font-weight: 600;
  color: #012171;
  text-align: center;
  line-height: 1.2;
  word-break: break-word;
  white-space: normal;
  overflow: hidden;
  padding: 4px 2px;
  box-sizing: border-box;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  line-clamp: 4;
}

.dh-at-vertical-header.long-name .dh-at-vertical-text {
  font-size: 8px;
  line-height: 1.1;
  padding: 3px 2px;
}

.dh-at-vertical-header.very-long-name .dh-at-vertical-text {
  font-size: 7px;
  line-height: 1.0;
  padding: 2px 1px;
  -webkit-line-clamp: 5;
  line-clamp: 5;
}

.dh-at-statistics-footer {
  padding: 16px !important;
  background: #f8fafc;
}

.dh-at-statistics-grid {
  margin-top: 30px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e2e8f0;
}

.dh-at-stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: white;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  text-align: center;
}

.dh-at-stat-item span:first-child {
  font-size: 12px;
  color: #64748b;
  margin-bottom: 4px;
}

.dh-at-stat-value {
  font-size: 18px;
  font-weight: 700;
  color: #002FA7;
}

.dh-at-na-stat {
  color: #dc2626 !important;
}

.dh-at-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(50, 64, 124, 0.3);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
}

.dh-at-modal-content {
  background: white;
  border-radius: 16px;
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  animation: modalSlideIn 0.3s ease;
  z-index: 1001;
}

.dh-at-attestation-modal {
  max-width: 550px;
  width: 100%;
}

.dh-at-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border-bottom: 1px solid #e2e8f0;
}

.dh-at-modal-header h3 {
  color: #002FA7;
  font-size: 16pt;
  font-weight: 600;
  margin: 0;
}

.dh-at-modal-close {
  background: none;
  border: none;
  font-size: 28px;
  color: #64748b;
  cursor: pointer;
  line-height: 1;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.dh-at-modal-close:hover {
  background: rgba(0, 47, 167, 0.1);
  color: #002FA7;
}

.dh-at-attestation-tabs {
  display: flex;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 0 24px;
}

.dh-at-tab-btn {
  padding: 12px 20px;
  background: none;
  border: none;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}

.dh-at-tab-btn:hover {
  color: #002FA7;
}

.dh-at-tab-btn.active {
  color: #002FA7;
}

.dh-at-tab-btn.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 2px;
  background: #002FA7;
  border-radius: 2px;
}

.dh-at-modal-body {
  padding: 24px;
}

.dh-at-na-info {
  background: #f0f7ff;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
  border-left: 4px solid #002FA7;
}

.dh-at-na-info p {
  margin: 6px 0;
  color: #1f2937;
}

.dh-at-na-info strong {
  margin: 6px 0;
  color: #1e40af;
  font-weight: 600;
}

.dh-at-form-group {
  margin-bottom: 16px;
}

.dh-at-form-group label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #1f2937;
  margin-bottom: 8px;
}

.dh-at-input,
.dh-at-textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  color: #1f2937;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.dh-at-input:focus,
.dh-at-textarea:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);
}

.dh-at-textarea {
  resize: vertical;
  min-height: 80px;
  font-family: inherit;
}

.dh-at-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 24px;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
  border-radius: 0 0 16px 16px;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media print {
  .scholarship-col-print,
  .grades-count-col-print {
    display: none !important;
  }
}

@media (max-width: 1024px) {
  .dh-at-vertical-header {
    width: 45px;
    min-width: 45px;
    max-width: 45px;
    height: 150px;
  }
  
  .dh-at-vertical-text {
    width: 150px;
    height: 45px;
    left: -52px;
    font-size: 8px;
  }
  
  .dh-at-vertical-header.long-name .dh-at-vertical-text {
    font-size: 7px;
  }
  
  .dh-at-vertical-header.very-long-name .dh-at-vertical-text {
    font-size: 6.5px;
  }
}

@media (max-width: 768px) {
  .dh-at-academic-section {
    padding: 24px;
  }

  .dh-at-section-title {
    font-size: 24px;
  }

  .dh-at-groups-grid {
    grid-template-columns: 1fr;
  }

  .dh-at-group-card {
    padding: 20px;
  }

  .dh-at-statement-header {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }

  .dh-at-statement-actions {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }

  .dh-at-filters-left {
    justify-content: flex-start;
    margin-right: 0;
    gap: 16px;
  }

  .dh-at-actions-right {
    justify-content: flex-end;
  }

  .dh-at-filter-select {
    min-width: 90px;
    padding: 7px 12px;
    font-size: 13px;
  }

  .dh-at-semester-btn {
    padding: 7px 14px;
    font-size: 13px;
    min-width: 40px;
  }

  .dh-at-filter-label {
    font-size: 13px;
  }

  .dh-at-table-container {
    font-size: 10px;
  }

  .dh-at-statement-table th,
  .dh-at-statement-table td {
    padding: 4px 6px;
    font-size: 9px;
  }

  .dh-at-student-name {
    min-width: 120px;
    max-width: 120px;
  }

  .dh-at-vertical-header {
    width: 35px;
    min-width: 35px;
    max-width: 35px;
    height: 120px;
  }
  
  .dh-at-vertical-text {
    width: 120px;
    height: 35px;
    left: -42px;
    font-size: 7px;
    padding: 3px 1px;
    -webkit-line-clamp: 3;
    line-clamp: 3;
  }
  
  .dh-at-vertical-header.long-name .dh-at-vertical-text {
    font-size: 6px;
    -webkit-line-clamp: 4;
    line-clamp: 4;
  }
  
  .dh-at-vertical-header.very-long-name .dh-at-vertical-text {
    font-size: 5.5px;
    -webkit-line-clamp: 5;
    line-clamp: 5;
  }

  .dh-at-statistics-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
}

@media (max-width: 480px) {
  .dh-at-academic-section {
    padding: 20px;
  }

  .dh-at-section-title {
    font-size: 20px;
  }

  .dh-at-filters-left {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    width: 100%;
  }

  .dh-at-filter-group {
    justify-content: space-between;
  }

  .dh-at-filter-select {
    flex: 1 1;
    max-width: 150px;
  }

  .dh-at-semester-buttons {
    flex: 1 1;
    justify-content: flex-end;
  }

  .dh-at-actions-right {
    justify-content: center;
    width: 100%;
    flex-direction: column;
  }

  .dh-at-actions-right button {
    flex: 1 1;
    width: 100%;
  }

  .dh-at-modal-footer {
    flex-direction: column;
  }

  .dh-at-btn-primary,
  .dh-at-btn-secondary,
  .dh-at-btn-print {
    width: 100%;
  }

  .dh-at-attestation-tabs {
    padding: 0 16px;
  }
  
  .dh-at-tab-btn {
    padding: 10px 16px;
    font-size: 13px;
  }

  .dh-at-vertical-header {
    width: 28px;
    min-width: 28px;
    max-width: 28px;
    height: 100px;
  }
  
  .dh-at-vertical-text {
    width: 100px;
    height: 28px;
    left: -36px;
    font-size: 6px;
    padding: 2px 1px;
    -webkit-line-clamp: 3;
    line-clamp: 3;
  }
  
  .dh-at-vertical-header.long-name .dh-at-vertical-text {
    font-size: 5px;
    -webkit-line-clamp: 4;
    line-clamp: 4;
  }
  
  .dh-at-vertical-header.very-long-name .dh-at-vertical-text {
    font-size: 4.5px;
    -webkit-line-clamp: 5;
    line-clamp: 5;
  }

  .dh-at-statistics-grid {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/dh-components/SummaryStatementSectionStyle.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,iCAAiC;EACjC,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;;;EAGE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,2BAA2B;EAC3B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,iCAAiC;EACjC,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,wCAAwC;EACxC,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;EAC3C,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;IACf,eAAe;IACf,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,2BAA2B;IAC3B,eAAe;IACf,SAAS;EACX;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,eAAe;IACf,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE,cAAc;IACd,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,SAAO;IACP,gBAAgB;EAClB;;EAEA;IACE,SAAO;IACP,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;IACvB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,SAAO;IACP,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;IAGE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,eAAe;IACf,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE,cAAc;IACd,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".dh-at-section {\n  background: white;\n  border-radius: 20px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);\n  border: 1px solid #f0f0f0;\n  overflow: hidden;\n}\n\n.dh-at-academic-section {\n  padding-bottom: 32px;\n}\n\n.dh-at-section-header {\n  background: white;\n  padding: 32px 0 0 40px;\n  border-bottom: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 10px;\n}\n\n.dh-at-section-title {\n  color: #002FA7;\n  font-size: 32px;\n  font-weight: 700;\n  margin: 0 0 24px 0;\n}\n\n.dh-at-section-subtitle {\n  color: #64748b;\n  font-size: 16px;\n  margin: 0;\n}\n\n.dh-at-filters {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  flex-wrap: wrap;\n  margin-bottom: 14px;\n  padding: 8px 32px 0 32px;\n}\n\n.dh-at-search-container {\n  flex: 1;\n  min-width: 250px;\n}\n\n.dh-at-search-input {\n  width: 100%;\n  padding: 10px 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 14px;\n  transition: all 0.3s ease;\n}\n\n.dh-at-search-input:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);\n}\n\n.dh-at-course-filter {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.dh-at-course-filter-btn {\n  padding: 8px 16px;\n  border: 1px solid #e2e8f0;\n  background: white;\n  color: #64748b;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.dh-at-course-filter-btn:hover {\n  border-color: #002FA7;\n  color: #002FA7;\n}\n\n.dh-at-course-filter-btn.active {\n  background: #002FA7;\n  color: white;\n  border-color: #002FA7;\n}\n\n.dh-at-courses-container {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  margin-top: 24px;\n}\n\n.dh-at-course-section {\n  width: 100%;\n}\n\n.dh-at-course-title {\n  font-size: 20px;\n  font-weight: 600;\n  color: #002FA7;\n  margin: 0 0 20px 0;\n  padding-bottom: 12px;\n  border-bottom: 2px dashed #e2e8f0;\n  position: relative;\n  padding: 0 32px 8px 32px;\n}\n\n.dh-at-groups-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 20px;\n  padding: 0 32px 0 32px;\n}\n\n.dh-at-group-card {\n  background: white;\n  border-radius: 16px;\n  padding: 20px;\n  border: 1px solid #e2e8f0;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.dh-at-group-card:hover {\n  border-color: #002FA7;\n  transform: translateY(-4px);\n  box-shadow: 0 12px 24px rgba(0, 47, 167, 0.12);\n}\n\n.dh-at-group-header {\n  margin-bottom: 16px;\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n}\n\n.dh-at-group-title {\n  font-size: 20px;\n  font-weight: 700;\n  color: #002FA7;\n  margin: 0;\n}\n\n.dh-at-group-badge {\n  background: #002FA7;\n  color: white;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.dh-at-group-info {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin: 0;\n}\n\n.dh-at-group-specialty {\n  font-size: 14px;\n  color: #64748b;\n  line-height: 1.4;\n  padding-bottom: 8px;\n  border-bottom: 1px dashed #e2e8f0;\n}\n\n.dh-at-group-details {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  font-size: 13px;\n  color: #1f2937;\n  margin: 0;\n}\n\n.dh-at-group-details span {\n  background: #f8fafc;\n  padding: 4px 12px;\n  border-radius: 20px;\n  color: #002FA7;\n  font-weight: 500;\n}\n\n.dh-at-group-students {\n  color: #002FA7;\n  font-size: 14px;\n  font-weight: 600;\n  margin: 0;\n}\n\n.dh-at-group-footer {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.dh-at-view-button {\n  background: #002FA7;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.dh-at-view-button:hover {\n  background: #1e40af;\n  transform: translateX(4px);\n}\n\n.dh-at-no-groups {\n  text-align: center;\n  padding: 60px 24px;\n  background: #f8fafc;\n  border-radius: 16px;\n  border: 2px dashed #e2e8f0;\n  color: #64748b;\n  font-size: 16px;\n}\n\n.dh-at-statement-wrapper {\n  height: 100%;\n  overflow: auto;\n}\n\n.dh-at-statement-header {\n  background: #f8fafc;\n  color: #002FA7;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  border-bottom: solid 1px #002fa7a3;\n  padding: 16px 24px;\n}\n\n.dh-at-statement-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n  width: 100%;\n}\n\n.dh-at-filters-left {\n  display: flex;\n  gap: 20px;\n  align-items: center;\n  flex-wrap: wrap;\n  margin-right: auto;\n}\n\n.dh-at-filter-group {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.dh-at-filter-label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #002FA7;\n  white-space: nowrap;\n}\n\n.dh-at-filter-select {\n  padding: 8px 14px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 400;\n  background: white;\n  cursor: pointer;\n  color: #1f2937;\n  min-width: 100px;\n  transition: all 0.2s ease;\n}\n\n.dh-at-filter-select:hover {\n  border-color: #002FA7;\n}\n\n.dh-at-filter-select:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);\n}\n\n.dh-at-semester-buttons {\n  display: flex;\n  gap: 6px;\n}\n\n.dh-at-semester-btn {\n  padding: 8px 18px;\n  border: 1px solid #d1d5db;\n  background: white;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #6b7280;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 44px;\n}\n\n.dh-at-semester-btn:hover {\n  border-color: #002FA7;\n  color: #002FA7;\n  background: #f0f7ff;\n}\n\n.dh-at-semester-btn.active {\n  background: #002FA7;\n  color: white;\n  border-color: #002FA7;\n  box-shadow: 0 2px 6px rgba(0, 47, 167, 0.3);\n}\n\n.dh-at-actions-right {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.dh-at-btn-primary,\n.dh-at-btn-secondary,\n.dh-at-btn-print {\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 14px;\n  border: 1px solid #8aa3c4b8;\n  background: white;\n  color: #002FA7;\n}\n\n.dh-at-btn-primary:hover,\n.dh-at-btn-secondary:hover,\n.dh-at-btn-print:hover {\n  transform: translateY(-1px);\n}\n\n.dh-at-main-content {\n  display: flex;\n  gap: 20px;\n}\n\n.dh-at-statement-body {\n  flex: 1 1 auto;\n  min-width: 0;\n  padding: 0;\n}\n\n.dh-at-table-container {\n  overflow-x: auto;\n  padding: 0;\n}\n\n.dh-at-statement-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 11px;\n  min-width: 2000px;\n}\n\n.dh-at-statement-table th,\n.dh-at-statement-table td {\n  border: 1px solid #9c9c9c81;\n  padding: 6px 8px;\n  text-align: center;\n  vertical-align: middle;\n}\n\n.dh-at-statement-table th {\n  background: #ffffff72;\n  color: #012171;\n  font-weight: 600;\n  position: sticky;\n  top: 0;\n}\n\n.dh-at-statement-table tr:nth-child(even) {\n  background: #f8fafc;\n}\n\n.dh-at-statement-table tr:hover {\n  background: #f0f7ff;\n}\n\n.dh-at-student-name {\n  text-align: left !important;\n  min-width: 180px;\n  max-width: 180px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dh-at-average {\n  font-weight: 600;\n  color: #002FA7;\n}\n\n.dh-at-grade-select {\n  width: 100%;\n  padding: 4px;\n  border: 1px solid #e2e8f0;\n  border-radius: 4px;\n  background: white;\n  font-size: 11px;\n  text-align: center;\n}\n\n.dh-at-na-button {\n  background: #002FA7;\n  color: white;\n  border: none;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 10px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  width: 100%;\n}\n\n.dh-at-na-button:hover {\n  background: #b91c1c;\n  transform: scale(1.05);\n}\n\n.dh-at-vertical-header {\n  width: 70px;\n  min-width: 70px;\n  max-width: 70px;\n  height: 250px;\n  position: relative;\n  vertical-align: bottom !important;\n  padding: 0 !important;\n  border-right: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.dh-at-vertical-text {\n  transform: rotate(-90deg);\n  transform-origin: center;\n  position: absolute;\n  top: 40%;\n  left: -55px;\n  width: 180px;\n  height: 60px;\n  font-size: 9px;\n  font-weight: 600;\n  color: #012171;\n  text-align: center;\n  line-height: 1.2;\n  word-break: break-word;\n  white-space: normal;\n  overflow: hidden;\n  padding: 4px 2px;\n  box-sizing: border-box;\n  display: -webkit-box;\n  -webkit-line-clamp: 5;\n  -webkit-box-orient: vertical;\n  line-clamp: 4;\n}\n\n.dh-at-vertical-header.long-name .dh-at-vertical-text {\n  font-size: 8px;\n  line-height: 1.1;\n  padding: 3px 2px;\n}\n\n.dh-at-vertical-header.very-long-name .dh-at-vertical-text {\n  font-size: 7px;\n  line-height: 1.0;\n  padding: 2px 1px;\n  -webkit-line-clamp: 5;\n  line-clamp: 5;\n}\n\n.dh-at-statistics-footer {\n  padding: 16px !important;\n  background: #f8fafc;\n}\n\n.dh-at-statistics-grid {\n  margin-top: 30px;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n  margin-bottom: 24px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.dh-at-stat-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: white;\n  padding: 12px;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  text-align: center;\n}\n\n.dh-at-stat-item span:first-child {\n  font-size: 12px;\n  color: #64748b;\n  margin-bottom: 4px;\n}\n\n.dh-at-stat-value {\n  font-size: 18px;\n  font-weight: 700;\n  color: #002FA7;\n}\n\n.dh-at-na-stat {\n  color: #dc2626 !important;\n}\n\n.dh-at-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(50, 64, 124, 0.3);\n  backdrop-filter: blur(4px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.dh-at-modal-content {\n  background: white;\n  border-radius: 16px;\n  width: 100%;\n  max-width: 600px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n  animation: modalSlideIn 0.3s ease;\n  z-index: 1001;\n}\n\n.dh-at-attestation-modal {\n  max-width: 550px;\n  width: 100%;\n}\n\n.dh-at-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.dh-at-modal-header h3 {\n  color: #002FA7;\n  font-size: 16pt;\n  font-weight: 600;\n  margin: 0;\n}\n\n.dh-at-modal-close {\n  background: none;\n  border: none;\n  font-size: 28px;\n  color: #64748b;\n  cursor: pointer;\n  line-height: 1;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  transition: all 0.3s ease;\n}\n\n.dh-at-modal-close:hover {\n  background: rgba(0, 47, 167, 0.1);\n  color: #002FA7;\n}\n\n.dh-at-attestation-tabs {\n  display: flex;\n  border-bottom: 1px solid #e2e8f0;\n  background: #f8fafc;\n  padding: 0 24px;\n}\n\n.dh-at-tab-btn {\n  padding: 12px 20px;\n  background: none;\n  border: none;\n  font-size: 14px;\n  font-weight: 500;\n  color: #64748b;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  position: relative;\n}\n\n.dh-at-tab-btn:hover {\n  color: #002FA7;\n}\n\n.dh-at-tab-btn.active {\n  color: #002FA7;\n}\n\n.dh-at-tab-btn.active::after {\n  content: '';\n  position: absolute;\n  bottom: -1px;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: #002FA7;\n  border-radius: 2px;\n}\n\n.dh-at-modal-body {\n  padding: 24px;\n}\n\n.dh-at-na-info {\n  background: #f0f7ff;\n  padding: 16px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  border-left: 4px solid #002FA7;\n}\n\n.dh-at-na-info p {\n  margin: 6px 0;\n  color: #1f2937;\n}\n\n.dh-at-na-info strong {\n  margin: 6px 0;\n  color: #1e40af;\n  font-weight: 600;\n}\n\n.dh-at-form-group {\n  margin-bottom: 16px;\n}\n\n.dh-at-form-group label {\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  color: #1f2937;\n  margin-bottom: 8px;\n}\n\n.dh-at-input,\n.dh-at-textarea {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #1f2937;\n  transition: all 0.3s ease;\n  box-sizing: border-box;\n}\n\n.dh-at-input:focus,\n.dh-at-textarea:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);\n}\n\n.dh-at-textarea {\n  resize: vertical;\n  min-height: 80px;\n  font-family: inherit;\n}\n\n.dh-at-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 24px;\n  border-top: 1px solid #e2e8f0;\n  background: #f8fafc;\n  border-radius: 0 0 16px 16px;\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media print {\n  .scholarship-col-print,\n  .grades-count-col-print {\n    display: none !important;\n  }\n}\n\n@media (max-width: 1024px) {\n  .dh-at-vertical-header {\n    width: 45px;\n    min-width: 45px;\n    max-width: 45px;\n    height: 150px;\n  }\n  \n  .dh-at-vertical-text {\n    width: 150px;\n    height: 45px;\n    left: -52px;\n    font-size: 8px;\n  }\n  \n  .dh-at-vertical-header.long-name .dh-at-vertical-text {\n    font-size: 7px;\n  }\n  \n  .dh-at-vertical-header.very-long-name .dh-at-vertical-text {\n    font-size: 6.5px;\n  }\n}\n\n@media (max-width: 768px) {\n  .dh-at-academic-section {\n    padding: 24px;\n  }\n\n  .dh-at-section-title {\n    font-size: 24px;\n  }\n\n  .dh-at-groups-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .dh-at-group-card {\n    padding: 20px;\n  }\n\n  .dh-at-statement-header {\n    flex-direction: column;\n    gap: 12px;\n    align-items: stretch;\n  }\n\n  .dh-at-statement-actions {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 16px;\n  }\n\n  .dh-at-filters-left {\n    justify-content: flex-start;\n    margin-right: 0;\n    gap: 16px;\n  }\n\n  .dh-at-actions-right {\n    justify-content: flex-end;\n  }\n\n  .dh-at-filter-select {\n    min-width: 90px;\n    padding: 7px 12px;\n    font-size: 13px;\n  }\n\n  .dh-at-semester-btn {\n    padding: 7px 14px;\n    font-size: 13px;\n    min-width: 40px;\n  }\n\n  .dh-at-filter-label {\n    font-size: 13px;\n  }\n\n  .dh-at-table-container {\n    font-size: 10px;\n  }\n\n  .dh-at-statement-table th,\n  .dh-at-statement-table td {\n    padding: 4px 6px;\n    font-size: 9px;\n  }\n\n  .dh-at-student-name {\n    min-width: 120px;\n    max-width: 120px;\n  }\n\n  .dh-at-vertical-header {\n    width: 35px;\n    min-width: 35px;\n    max-width: 35px;\n    height: 120px;\n  }\n  \n  .dh-at-vertical-text {\n    width: 120px;\n    height: 35px;\n    left: -42px;\n    font-size: 7px;\n    padding: 3px 1px;\n    -webkit-line-clamp: 3;\n    line-clamp: 3;\n  }\n  \n  .dh-at-vertical-header.long-name .dh-at-vertical-text {\n    font-size: 6px;\n    -webkit-line-clamp: 4;\n    line-clamp: 4;\n  }\n  \n  .dh-at-vertical-header.very-long-name .dh-at-vertical-text {\n    font-size: 5.5px;\n    -webkit-line-clamp: 5;\n    line-clamp: 5;\n  }\n\n  .dh-at-statistics-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 12px;\n  }\n}\n\n@media (max-width: 480px) {\n  .dh-at-academic-section {\n    padding: 20px;\n  }\n\n  .dh-at-section-title {\n    font-size: 20px;\n  }\n\n  .dh-at-filters-left {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n    width: 100%;\n  }\n\n  .dh-at-filter-group {\n    justify-content: space-between;\n  }\n\n  .dh-at-filter-select {\n    flex: 1;\n    max-width: 150px;\n  }\n\n  .dh-at-semester-buttons {\n    flex: 1;\n    justify-content: flex-end;\n  }\n\n  .dh-at-actions-right {\n    justify-content: center;\n    width: 100%;\n    flex-direction: column;\n  }\n\n  .dh-at-actions-right button {\n    flex: 1;\n    width: 100%;\n  }\n\n  .dh-at-modal-footer {\n    flex-direction: column;\n  }\n\n  .dh-at-btn-primary,\n  .dh-at-btn-secondary,\n  .dh-at-btn-print {\n    width: 100%;\n  }\n\n  .dh-at-attestation-tabs {\n    padding: 0 16px;\n  }\n  \n  .dh-at-tab-btn {\n    padding: 10px 16px;\n    font-size: 13px;\n  }\n\n  .dh-at-vertical-header {\n    width: 28px;\n    min-width: 28px;\n    max-width: 28px;\n    height: 100px;\n  }\n  \n  .dh-at-vertical-text {\n    width: 100px;\n    height: 28px;\n    left: -36px;\n    font-size: 6px;\n    padding: 2px 1px;\n    -webkit-line-clamp: 3;\n    line-clamp: 3;\n  }\n  \n  .dh-at-vertical-header.long-name .dh-at-vertical-text {\n    font-size: 5px;\n    -webkit-line-clamp: 4;\n    line-clamp: 4;\n  }\n  \n  .dh-at-vertical-header.very-long-name .dh-at-vertical-text {\n    font-size: 4.5px;\n    -webkit-line-clamp: 5;\n    line-clamp: 5;\n  }\n\n  .dh-at-statistics-grid {\n    grid-template-columns: 1fr;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
